var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProfileImage',{staticClass:"my-1",attrs:{"size":_vm.size,"image":_vm.avatar.image,"alt":_vm.avatar.name}})}
var staticRenderFns = []

export { render, staticRenderFns }